import { getClassFunction } from '@helpers/functions';

const getClass = getClassFunction('kf-o-share-overlay-inline');

window.KFShareOverlayInline = window.KFShareOverlayInline || {
  elements: document.querySelectorAll(getClass(undefined, { checkAttached: true })),
  init() {
    this.elements = document.querySelectorAll(getClass(undefined, { checkAttached: true }));
    [].forEach.call(this.elements, (el: HTMLElement) => {
      this.setupShareOverlayInline(el);
    });
  },
  setupShareOverlayInline(el: HTMLElement) {
    if (!el) return;

    el.dataset.eventAttached = 'true';

    el.addEventListener('click', async (evt) => {
      try {
        const target = evt.target as HTMLElement;
        const btn = target.closest?.('[data-copy-link]') as HTMLButtonElement | null;

        if (!btn) return;
        evt.preventDefault();
        const value = btn.dataset.copyLink;

        if (!value) return;
        await navigator.clipboard.writeText(value);
      } catch {
        // No-op: prevent errors from breaking the page
      }
    });
  },
};

window.KFShareOverlayInline.init();
export {};
